import React, { FC, ReactNode } from 'react';
import { TooltipBtn } from '../../TooltipBtn';
import { TooltipTip } from '../../Tooltip';
import classes from './styles/index.module.scss';
import classNames from 'classnames';
import { gray } from '../../Color';
import { InfoCircleO } from '../../Icons/InfoCircleO';

type ControlGroupTipProps = {
	className?: string;
	tipMessage?: ReactNode;
	noMargin?: boolean;
	fill?: string;
	tipBtnStopPropagation?: boolean;
	icon?: JSX.Element;
};

export const ControlGroupTip: FC<React.PropsWithChildren<ControlGroupTipProps>> = ({
	className,
	tipMessage,
	noMargin,
	fill = gray[5],
	tipBtnStopPropagation,
	icon,
}) => {
	const tooltipComponent = <TooltipTip className={classes.tipContent}>{tipMessage}</TooltipTip>;

	const componentClasses = classNames(classes.tipBtn, className, {
		[classes.tipBtn__noMargin]: noMargin,
	});

	return (
		<TooltipBtn
			className={componentClasses}
			tooltip={tooltipComponent}
			tooltipPosition='bottom'
			tooltipAlign='start'
			stopPropagation={tipBtnStopPropagation}
			dataTestId='controlGroupTipButton'
			tabIndex={-1}
		>
			{icon || <InfoCircleO fill={fill} />}
		</TooltipBtn>
	);
};

export { ControlGroupTip as default };
